import { render } from "./CardPage.vue?vue&type=template&id=9c439430&scoped=true"
import script from "./CardPage.vue?vue&type=script&lang=js"
export * from "./CardPage.vue?vue&type=script&lang=js"

import "./CardPage.vue?vue&type=style&index=0&id=9c439430&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c439430"]])

export default __exports__